import { VisitDetail } from '@features/visits/entity';
import ProcedureList from './ProcedureList';

type PreviousVisitProceduresProps = {
  previousVisit: VisitDetail | null;
  hasNoProcedures: boolean;
  isVisitClosed: boolean;
};

const PreviousVisitProcedures = ({
  previousVisit,
  hasNoProcedures,
  isVisitClosed,
}: PreviousVisitProceduresProps) => {
  if (isVisitClosed || !previousVisit || !hasNoProcedures) {
    return null;
  }

  const consumptionProcedures = previousVisit.procedures.filter(p => p.type === 'CONSUMPTION');

  return <ProcedureList procedures={consumptionProcedures} isVisitClosed={false} isPreviousCopy />;
};

export default PreviousVisitProcedures;
